export const CountryStateFactory = () => {
    return function CountryState() {

        this.id = null;
        this.name = null;
    };
};
